import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { ReadOnlyWithLexicalTags } from '../ReadOnlyWithLexicalTags';
import { H5 } from '../../../../../components';

const TermTranslationsContainer = styled.div`
  display: flex;
  row-gap: 12px;
  border-radius: 8px;
  align-items: center;
  flex-direction: column;
  align-items: flex-start;
`;

const TermTranslationsItemContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: flex-start;
  margin-left: 10px;
`;

const QueryExplanationContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const QueryExplanationLabel = styled(H5)`
  margin-bottom: 8px;
`;

const TermTranslations = ({ className = null, queryExplanation = null }) => (
  <TermTranslationsContainer className={className}>
    {queryExplanation && (
      <QueryExplanationContainer>
        <QueryExplanationLabel color='var(--content-body)'>
          Important context for the results:
        </QueryExplanationLabel>
        <TermTranslationsItemContainer>
          <ReadOnlyWithLexicalTags text={queryExplanation} namespace='QueryExplanation' />
        </TermTranslationsItemContainer>
      </QueryExplanationContainer>
    )}
  </TermTranslationsContainer>
);

TermTranslations.propTypes = {
  className: PropTypes.string,
  queryExplanation: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
};

export { TermTranslations };
